import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { delay, finalize } from 'rxjs/operators';
import { AppService } from '../../../services/app.service';
import { PlanSummaryService } from '../../../services/plan-summary.service';
import { ICurrentRequest, getCurrentRequest } from '../plan-summary.component';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-plan-summary-edit-medical-person-id',
    templateUrl: './plan-summary-edit-medical-person-id.component.html'
})
export class PlanSummaryEditMedicalPersonIdComponent implements OnInit, OnDestroy {
    constructor(
        public app: AppService,
        private service: PlanSummaryService,
        private activeModal: NgbActiveModal
    ) { }

    @Input() studentId: string;
    @Input() medicalPersonId: string;

    isSaving: boolean;

    private request: ICurrentRequest;
    private requestSub: Subscription;

    ngOnInit() {
        this.requestSub = getCurrentRequest().subscribe(req => {
            this.request = req;
        });
    }

    ngOnDestroy() {
        this.requestSub?.unsubscribe();
    }

    submit() {
        this.isSaving = true;

        this.service.updateMedicalPerson({
            medicalPersonId: this.medicalPersonId || '',
            studentId: this.studentId
        }, this.request.params)
            .pipe(delay(500), finalize(() => this.isSaving = false))
            .subscribe(() => {
                this.activeModal.close(this.medicalPersonId);
            });
    }

    cancel() {
        this.activeModal.dismiss();
    }
}
